module.exports = __webpack_public_path__ + "static/media/cathedraloutside.b33ae8f5.png";